<script lang="ts">
    import { onDestroy } from 'svelte'
    import { fade } from 'svelte/transition'

    import { orderBy } from 'lodash-es'

    import { lg } from 'hydria/services/language'
    import { simpleFetch } from 'hydria/services/session'

    const unsubs: any[] = []
    onDestroy(() => {
        for (const unsub of unsubs) unsub.unsubscribe != null ? unsub.unsubscribe() : unsub()
    })

    interface Props {
        wasDeleg?: boolean
        onclose: () => void
    }

    let { wasDeleg = false, onclose }: Props = $props()

    let loading = $state(true)
    let articles: ServerArticle[] = $state([])

    interface SimpleAlt {
        url: string
        width: number
        height: number
        mimetype: string
    }

    interface ServerArticle {
        url_title: string
        title: string
        content_home_html: string
        url: string
        vignette_ilist: SimpleAlt[]
        tags: string
        vignette_by_mime: [string, SimpleAlt[]][]
        vignette_fallback?: SimpleAlt
    }

    const ALT_FORMAT_PRIORITY = ['image/avif', 'image/webp', 'image/jpeg', 'image/png']

    function altsByMimetype(alts: SimpleAlt[]): [string, SimpleAlt[]][] {
        const byMime: { [key: string]: SimpleAlt[] } = {}

        for (const alt of alts) {
            if (byMime[alt.mimetype] == null) byMime[alt.mimetype] = []
            byMime[alt.mimetype].push(alt)
        }

        return orderBy(
            Object.entries(byMime),
            [
                ([mimetype, alts]) => {
                    const i = ALT_FORMAT_PRIORITY.indexOf(mimetype)
                    if (i >= 0) return i
                    return 999
                },
            ],
            ['asc'],
        )
    }

    function imageFallback(alts: SimpleAlt[]): SimpleAlt | undefined {
        if (!alts || !alts.length) return undefined

        const candidates = orderBy(
            alts.filter((alt) => ['image/jpeg', 'image/png', 'image/svg+xml'].includes(alt.mimetype)),
            [(alt) => alt.width],
            ['asc'],
        )

        return candidates.length ? candidates[0] : undefined
    }

    function prepArticle(item: ServerArticle) {
        item.vignette_by_mime = altsByMimetype(item.vignette_ilist)
        item.vignette_fallback = imageFallback(item.vignette_ilist)
        return item
    }

    async function load() {
        try {
            const r = await simpleFetch('GET', `/${$lg}/signed-out-news`, { deleg: wasDeleg ? '1' : null })
            articles = r.data.articles.map(prepArticle)
        } catch {}
        loading = false
    }
    load()

    function makeSrcset(alts: SimpleAlt[]): string {
        const pieces: string[] = []
        for (const img of alts) {
            pieces.push(`${img.url} ${img.width}w`)
        }

        return pieces.join(', ')
    }
</script>

<style>
    /* .modal-backdrop {
        z-index: 0;
    }
    .modal-content {
        z-index: 1;
    } */

    .modal-header.text-bg-primary {
        background-color: var(--p-darker) !important;
    }
</style>

<svelte:window
    onkeydown={(e) => {
        if (e.key == 'Escape') onclose()
    }}
/>

<div id="signed-out-alert" class="modal" role="dialog" transition:fade={{ duration: 250 }}>
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header text-bg-primary">
                <h5 class="modal-title">{$lg == 'fr' ? 'Déconnexion réussie' : 'Signed out successfully'}</h5>
                <!-- <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" on:click|preventDefault={() => onclose()} /> -->
            </div>
            <div class="modal-body">
                {#if loading}
                    <div class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div>
                {:else}
                    {#each articles as article}
                        <div class="row-flex article odd">
                            <div class="col-flex-5">
                                <div class="article-img">
                                    <picture>
                                        {#each article.vignette_by_mime as [mimetype, alts]}
                                            <source type={mimetype} srcset={makeSrcset(alts)} sizes="300px" />
                                        {/each}
                                        {#if article.vignette_fallback}
                                            <img src={article.vignette_fallback.url} alt="Vignette" />
                                        {/if}
                                    </picture>
                                </div>
                            </div>
                            <div class="col-flex-7">
                                <h2>{article.title}</h2>
                                {#if article.tags}{article.tags}{/if}
                                {@html article.content_home_html}
                                <a href={article.url}>{$lg == 'fr' ? 'Voir plus' : 'See more'}</a>
                            </div>
                        </div>
                    {/each}
                {/if}
            </div>
            <div class="modal-footer text-bg-light">
                <button type="button" class="btn btn-secondary" onclick={() => onclose()}>{$lg == 'fr' ? 'Fermer' : 'Close'}</button>
            </div>
        </div>
    </div>
    <div class="modal-backdrop" onclick={() => onclose()} aria-hidden="true"></div>
</div>
